import { ProjectShell } from "@/components/shell/project-shell";
import { useParams } from "@/lib/router/navigation";

/**
 * Reads the project id from the route rather than from awaited server params:
 * a static SPA resolves it in the browser (RAD §7.2).
 */
export default function ProjectLayout({ children }: { children: React.ReactNode }) {
  const { projectId = "" } = useParams<{ projectId: string }>();
  return <ProjectShell projectId={projectId}>{children}</ProjectShell>;
}
